import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import PageContainer from './PageContainer';

import coverImage from './images/meista.jpg';

function PageMeista() {
	return (
	<PageContainer header='Meistä' header_variant='h3' header_image={coverImage} header_image_position={65}>
        <Box sx={{textAlign:'center'}}>
            <Typography variant='h4' sx={{mb:2}}>
            Hei ja tervetuloa meidän kissakahvilaan!
            </Typography>
            <Typography sx={{mb:2}}>
                Kaikki lähti liikkeelle kissasta nimeltään Mirri. Arvioltaan vuonna 2014 syntynyt Mirri on hyvin uniikki kissa, joka on aikanaan ollut tallikissa. Hän oli hyvin ujo ja pelkäsi ihmisiä ja häntä ei helposti saanut kiinni. Kun hänet vihdoin saatiin eläinlääkäriin leikattavaksi, hänen sisältään löytyi kuollut pentu. Jos sterilisaatio olisi tehty edes päivää myöhemmin, Mirri ei olisi selvinnyt.
Mirri muutti 2020 Turkuun, jolloin hänen elämänsä muuttui täysin. Hänestä oli muovautumassa kaupunkilaisruovua.
Vieraiden tullessaan kylään, häntä ei näkynyt juuri koskaan. Ajan myötä hän tottui ihmisiin. Tunnelman ollessa rauhallinen, hän tuli haistelemaan vieraita.
            </Typography>
            <Typography sx={{mb:2}}>
                Curiosity killed the cat, but satisfaction brought it back.
(uteliaisuus tappoi kissan mutta tyytyväisyys toi sen takaisin)
            </Typography>
            <Typography sx={{mb:2}}>
                Ajan myötä Mirri oppi luottamaan ihmisiin ja nauttimaan niiden seurasta. Mirri asui kissakahvilassa tammikuusta lokakuuhun 2025 ja ehti hurmata monet asiakkaat lempeällä läsnäolollaan. Nykyään Mirri nauttii eläkepäivistä yrittäjän kotona, tervehtimässä vieraita ja tehdessään mitä ikinä haluaa.
            </Typography>
            <Typography sx={{mb:2}}>
                Mirri on opettanut kärsivällisyyttä, lempeyttä ja rajoja. Kissakahvila Mirrissä mennään kissojen ehdoilla, sillä heidän kotia ja tilaa täytyy kunnioittaa. Kissat päättävät milloin he haluaa huomiota, nukkua tai leikkiä. 
Kissat eivät palvele asiakkaita, vaan ihmiset palvelevat kissoja.
Kissakahvila Mirri kehittyy jatkuvasti eteenpäin ja löydät meidät Instagramista, TikTokista, Facebookista.
 <Link href="https://www.instagram.com/kissakahvila.mirri/" target="_blank">@kissakahvila.mirri</Link>
            </Typography>
            <Typography sx={{mb:2}}>
                Kiitos, että olet osa tätä unelmaa. Odotamme innolla, että pääsemme toivottamaan sinut tervetulleeksi!
            </Typography>
            <Box sx={{ mt: 5, textAlign: "left" }}>

    <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
        Lue lisää
    </Typography>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://kissakahvilat.fi/kissakahvila-mirri/"
            target="_blank"
            rel="noopener noreferrer"
        >
            Kissakahvilat.fi
        </Link>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://tutka.pro/kulttuuri/kahvia-ja-kehraysta-vai-kovaa-stressia-kissakahvilan-arki-voi-stressata-tai-aktivoida/"
            target="_blank"
            rel="noopener noreferrer"
        >
            Kahvia ja kehräystä vai kovaa stressiä? – Kissakahvilan arki voi stressata tai aktivoida
        </Link>

        <Typography variant="body2">
            Tutka · 04.05.2026
        </Typography>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://www.catswoppr.io/post/a-cat-cafe-in-turku-the-old-capital-of-finland"
            target="_blank"
            rel="noopener noreferrer"
        >
            A Cat Café in Turku, the Old Capital of Finland
        </Link>

        <Typography variant="body2">
            Catswoppr · 09.12.2025
        </Typography>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://tutka.pro/ihmiset/iris-laineste-toteutti-unelmansa-kissakahvila-mirri-tuo-kissojen-rauhan-keskelle-turun-keskustaa/"
            target="_blank"
            rel="noopener noreferrer"
        >
            Iris Laineste toteutti unelmansa – Kissakahvila Mirri tuo kissojen rauhan keskelle Turun keskustaa
        </Link>

        <Typography variant="body2">
            Tutka · 10.12.2025
        </Typography>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://www.ts.fi/a/6696922"
            target="_blank"
            rel="noopener noreferrer"
        >
            Pystyisitkö päihittämään santsikuppien ennätyksen? Tällainen on Turun ainoa kissakahvila
        </Link>

        <Typography variant="body2">
            Turun Sanomat · 24.06.2025
        </Typography>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://aamuset.fi/artikkeli/6628965"
            target="_blank"
            rel="noopener noreferrer"
        >
            Kissakahvila Mirrissä maistuvat virolaiset maut
        </Link>

        <Typography variant="body2">
            Aamuset kaupunkimedia · 16.04.2025
        </Typography>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://turunseutusanomat.fi/2025/03/turussa-uusi-kahvilakonsepti-ilahduttaa-rentoudellaan/"
            target="_blank"
            rel="noopener noreferrer"
        >
            Turussa uusi kahvilakonsepti ilahduttaa rentoudellaan ja aukioloajoillaan
        </Link>

        <Typography variant="body2">
            Turun Seutu Sanomat · 20.03.2025
        </Typography>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://www.ts.fi/a/6539599"
            target="_blank"
            rel="noopener noreferrer"
        >
            Iris keksi yläkoulussa liikeidean: kohta Marttiin avautuu kahvila, jonka kaltaista ei Turusta vielä löydy
        </Link>

        <Typography variant="body2">
            Turun Sanomat · 18.01.2015
        </Typography>
    </Box>

    <Box sx={{ mb: 3 }}>
        <Link
            href="https://www.abounderrattelser.fi/artikel/mirri-och-keiju-far-snart-manga-nya-vanner-abo-far-ett-kattkafe/"
            target="_blank"
            rel="noopener noreferrer"
        >
            Mirri och Keiju får snart många nya vänner – Åbo får ett kattkafé
        </Link>

        <Typography variant="body2">
            Åbo Underrättelser · 30.12.2024
        </Typography>
    </Box>

</Box>
        </Box>
	</PageContainer>
    );
}

export default PageMeista;